module.exports = new __parcel__URL__("logo.63bd902e.svg").toString();